<!-- 平台价格策略加价 -->
<template>
   <div class="strategy-rate-content">
      <div class="strategy-form">
         <div class="form-item">

            <div class="platform-rate-container">
               <div v-for="platform in platformList" :key="platform.appId" class="platform-rate-item">
                  <div class="platform-info">
                     <el-checkbox v-model="platform.enabled">
                        {{ platform.appName }}
                     </el-checkbox>
                  </div>
                  <div class="rate-input">
                     <el-input v-model="platform.priceRate" :min="0" type="number" placeholder="输入比例" size="mini" style="width: 120px"></el-input>
                     <span class="rate-unit">%</span>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="dialog-footer">
         <el-button @click="cancel">取 消</el-button>
         <el-button type="primary" @click="submitRate" :loading="saving">确 定</el-button>
      </div>
   </div>
</template>

<script>
export default {
   props: ["actionData"],
   name: "ptStrategyRate",
   data() {
      return {
         saving: false,
         platformList: []
      }
   },
   computed: {},
   watch: {},
   methods: {
      // 初始化平台数据
      async initPlatformData() {
         try {
            const res = await this.$http.getPlatformList({});
            if (res.status === 200) {
               this.platformList = (res.result || []).map(platform => ({
                  ...platform,
                  enabled: false,    // 是否启用加价
                  priceRate: 0    // 加价值
               }));
            }
         } catch (error) {
            console.error('获取平台列表失败:', error);
            this.$message.error('获取平台列表失败');
         }
      },


      // 提交加价设置
      async submitRate() {
   
   

         this.saving = true;
         try {
            const rateData = {
               bgsId: this.actionData.oldData.bgsId,
               detailList: this.platformList.map(platform => ({
                  appId: platform.appId,
                  appName: platform.appName,
                  priceRate: Number(platform.priceRate)
               }))
            };

            const res = await this.$http.changePriceInfoByRate(rateData);
            if (res.status === 200) {
               this.$message.success(res.message);
               this.$emit("drawerCancel", false);
               this.$emit("toDetail", rateData);
            } else {
               this.$message.error(res.message || '加价设置失败');
            }
         } catch (error) {
            console.error('加价设置失败:', error);
            this.$message.error('加价设置失败');
         } finally {
            this.saving = false;
         }
      },

      // 取消操作
      cancel() {
         this.$confirm("确认关闭弹窗吗？未保存的数据将丢失。", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit("drawerCancel", false);
            })
            .catch(() => { });
      }
   },
   async created() {
      await this.initPlatformData();
   }
}
</script>

<style scoped>
.strategy-rate-content {
   padding: 20px;
   max-height: 80vh;
   overflow-y: auto;
}

.strategy-form {
   width: 100%;
}

.dialog-footer {
   display: flex;
   justify-content: center;
   align-items: center;
   width: 100%;
   background: #fff;
   height: 60px;
   padding: 15px 20px;
   margin-top: 20px;
   border-top: 1px solid #eee;
   gap: 15px;
}

.dialog-footer .el-button {
   min-width: 100px;
   height: 36px;
}

/* 表单样式优化 */
.form-item {
   margin-bottom: 20px;
}

.form-label {
   display: block;
   font-weight: 600;
   color: #606266;
   margin-bottom: 15px;
   font-size: 14px;
}

/* 输入框样式 */
::v-deep .el-input-number .el-input__inner {
   text-align: left;
}

/* 滚动条样式 */
.strategy-rate-content::-webkit-scrollbar {
   width: 6px;
}

.strategy-rate-content::-webkit-scrollbar-track {
   background: #f1f1f1;
   border-radius: 3px;
}

.strategy-rate-content::-webkit-scrollbar-thumb {
   background: #c1c1c1;
   border-radius: 3px;
}

.strategy-rate-content::-webkit-scrollbar-thumb:hover {
   background: #a8a8a8;
}



.platform-rate-item {
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 10px 0;
   border-bottom: 1px solid #ebeef5;
}

.platform-rate-item:last-child {
   border-bottom: none;
}

.platform-info {
   flex: 1;
   min-width: 120px;
}

.rate-input {
   display: flex;
   align-items: center;
   gap: 8px;
}

.rate-unit {
   color: #909399;
   font-size: 14px;
   min-width: 20px;
}

::v-deep .platform-rate-item .el-checkbox {
   font-weight: 500;
}

::v-deep .platform-rate-item .el-checkbox__label {
   color: #303133;
}

/* 响应式设计 */
@media (max-width: 768px) {
   .strategy-rate-content {
      padding: 15px;
   }

   ::v-deep .el-form-item__label {
      width: 100px !important;
   }

   .platform-rate-item {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
   }

   .rate-input {
      width: 100%;
      justify-content: flex-start;
   }
}
</style>
